import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import EnableAccount from './EnableAccount';

const PaymentCancel = () => {
  let [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	useEffect (()=>{
		console.log("Payment canceled: ", token);
	}, [token])
	return (
		<>
		<Typography variant = 'h6'>Payment Canceled</Typography>
		<EnableAccount
			msgBefore={"You can try to make the payment again"}
			msgAfter={"Or you can safely close this page"}
			showTrial = {false}
			introMessage={()=> {}}
			></EnableAccount>
		{/* <Typography>You can close this page</Typography> */}
		</>
	);
};

export default PaymentCancel;